import { ListContentNode } from '@helo/cms'

import { ListContentNodeParts } from '../../datatypes/list/listContentNode.parts'

export type DrawerCardDisplayState = 'loading' | 'done' | 'no-data'

const resolveDrawerCardDisplayState = ({
  isLoading,
  itemList,
}: {
  isLoading?: boolean
  itemList?: ListContentNode | unknown[] | null
}): DrawerCardDisplayState => {
  if (isLoading) return 'loading'

  if (itemList === undefined) return 'done'

  const itemData = ListContentNodeParts.resolveListItemData(itemList)

  if (Array.isArray(itemData) && itemData.length > 0) {
    return 'done'
  }

  if (ListContentNodeParts.getRawListDataCount(itemList) > 0) {
    return 'done'
  }

  if (ListContentNodeParts.isListPending(itemList, false)) {
    return 'loading'
  }

  if (ListContentNodeParts.isConfirmedEmpty(itemList, isLoading)) {
    return 'no-data'
  }

  return 'loading'
}

export const DrawerCardState = {
  resolveDrawerCardDisplayState,
  resolveListItemData: ListContentNodeParts.resolveListItemData,
}
